import { useSyncExternalStore } from 'react'
import { getModalState } from '../../app-state/modals'
import { FloaterSize } from '../../constants/enums'
import { subFloatingRoom } from './useModal'

export const getPassiveState = (): boolean =>
    getModalState().floating_room.show &&
    getModalState().floating_room.size === FloaterSize.Fullscreen

/**
 * gets the status of whether or not the app should be reducing work done or not
 * @returns true if the app should be in passive mode
 * */

export const usePassive = (): boolean => {
    // this could be changed to be a separate value that's updated as needed if we
    //  want to use this for other things (like offering a general performance mode
    //  or if there's uses beyond just the floating room)
    return useSyncExternalStore(
        subFloatingRoom,
        getPassiveState,
        getPassiveState,
    )
}
